import { assertValidVersion } from "@tsparticles/engine";
import { BaseMover } from "./BaseMover.js";
export async function loadBaseMover(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addMover("base", () => {
        return Promise.resolve(new BaseMover());
    }, refresh);
}
